<template>
  <modal
    :name="name"
    :adaptive="true"
    :max-width="maxWidth"
    :width="width"
    :height="height"
    class="generic-notification-modal"
    :style="{
      '--gap': gap,
    }"
    :clickToClose="false"
  >
    <section class="generic-notification">
      <div
        v-if="image"
        class="generic-notification__image-block"
      >
        <img :src="image">
      </div>

      <h3
        v-if="title"
        class="generic-notification__title"
      >
        {{ title }}
      </h3>

      <notification-bar
        v-if="notificationBar"
        v-bind="notificationBar"
        class="generic-notification__alert"
      >
        <slot 
          v-if="$slots.notification" 
          name="notification" 
        />

        <template v-else-if="notificationBar.text">
          {{ notificationBar.text }}
        </template>
      </notification-bar>

      <div 
        v-if="subtitle || $slots.default"
        class="generic-notification__description">
        <h4
          v-if="subtitle"
          class="generic-notification__description-title"
        >
          {{ subtitle }}
        </h4>
        <p
          v-if="$slots.default"
          class="generic-notification__description-text"
        >
          <slot />
        </p>
      </div>

      <!-- TODO: insert some action -->
      <div class="generic-notification__action">
        <a
          class="generic-notification__action-skip"
          @click="handleClickSkip"
        >
          Skip for now
        </a>
        <PrimaryButton
          v-if="actionText"
          class="generic-notification__action-button"
          @click="handleClickAction"
        >
          {{ actionText }}
        </PrimaryButton>
      </div>
    </section>
  </modal>
</template>

<script>
import PrimaryButton from '../../common/PrimaryButton.vue';

export default {
  components: {
    PrimaryButton,
  },
  props: {
    name: {
      type: String,
      default: 'generic-notification',
    },
    image: {
      type: String,
    },
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
    },
    actionText: {
      type: String,
    },
    notificationBar: {
      type: Object,
    },
    maxWidth: {
      type: [Number, String],
      default: 600,
    },
    width: {
      type: [Number, String],
      default: '95%',
    },
    height: {
      type: [Number, String],
      default: 'auto',
    },
    gap: {
      type: String,
      default: '32px',
    },
  },
  mounted() {
    // TODO: remove after QA
    this.$modal.show(this.name)
  },
  methods: {
    closeModal() {
      this.$modal.hide(this.name);
    },
    handleClickSkip() {
      this.closeModal();
      this.$emit('onSkip');
    },
    handleClickAction() {
      this.closeModal();
      this.$emit('onAction');
    }
  }
};

</script>

<style scoped lang="scss">
@import '../../common/variables';
@import '../../common/style/_utils';

$fonts: DM Sans, Open Sans, sans-serif;

.v--modal-overlay {
  z-index: 99999;
  overflow-y: auto;
}

.generic-notification-modal {
  font-size: 16px;

  @media screen and (max-width: 600px) {
    font-size: 13px;
  }

  @media screen and (max-width: 500px) {
    font-size: 10px;
  }
}

.generic-notification {
  margin: 0 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--gap);
  padding: pxToEm(56, 64);
  font-family: $fonts;
  overflow-y: auto;

  &__title {
    font: 700 pxToEm(30)/1.3 IBM Plex Serif, $fonts;
    text-align: center;
  }

  &__description {
    &-title {
      font-size: pxToEm(24);
      color: $primary-blue;
      margin-bottom: 12px;
    }

    &-text {
      font-size: 14px;
    }
  }

  &__alert {
    border-radius: 5px;
  }

  &__action {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    &-skip {
      text-decoration: underline;
      font-weight: $font-bold;
      color: $title-grey !important;
      cursor: pointer;
      &:hover {
        opacity: 0.8;
      }
    }
    &-button {
      margin: 0;
      padding: 16px 18px; 
      border: 0;
    }
  }
}

::v-deep() {
  .notification-bar {
    @media screen and (max-width: 600px) {
      &__icon-box {
        display: none;
      }

      &__content-html {
        max-width: 100% !important;
      }
    }
  }
}
</style>